import { render, staticRenderFns } from "./ModalUpdateIngredient.vue?vue&type=template&id=4445ee28"
import script from "./ModalUpdateIngredient.vue?vue&type=script&lang=js"
export * from "./ModalUpdateIngredient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports